import { captureError } from '@smg-real-estate/browser-rum';
import { Store } from 'vuex';

const handleErrorWithNotification = async (
  callback: (...args: any[]) => any,
  $store: Store<any>,
  options: { keepLoadingState?: boolean; insertionId?: string } = {
    keepLoadingState: false,
    insertionId: undefined,
  },
): Promise<any> => {
  try {
    $store.commit('setFunnelApiLoading');

    if (options.insertionId) {
      $store.commit('updateApiCallById', options.insertionId);
    }

    const response = await callback();

    if (options.insertionId) {
      $store.commit('updateApiCallById', undefined);
    }

    if (!options.keepLoadingState) {
      $store.commit('resetFunnelApiStates');
    }

    return response;
  } catch (e) {
    $store.commit('setFunnelApiError', e);
    $store.commit('updateApiCallById', undefined);

    captureError(e);
  }
};

export default handleErrorWithNotification;
